import React, { createContext, useState } from "react";
import ls from "store2";
import { jwtDecode } from "jwt-decode";
export const SidebarContext = createContext();

const SidebarContextProvider = ({ children }) => {
  // -------------handle elderly back button and elderly trends click------------
  const [innerOverView, setinnerOverView] = useState(true);
  const [activeTrend, setActiveTrend] = useState({
    title: "Fall Detection",
    index: 1,
  });

  // --------------show notification tab------------
  const [showNotificationTab, setShowNotificationTab] = useState(false);

  // -------------inner device show---------------
  const [deviceInner, setDeviceInner] = useState("");

  const [show, setShow] = useState(false);
  const [sidebarShow, setSidebarShow] = useState(false);
  const [overView, setOverView] = useState(true);
  const [overViewActive, setOverViewActive] = useState("");
  const [BreadCrumbData, setBreadCrumb] = useState({ title: "", url: "" });
  const [role, setRole] = useState("");
  const [allRoles, setAllRoles] = useState({
    superAdmin: "super_admin",
    distributor: "distributor",
    office: "office",
    officManager: "office_manager",
    salesAgent: "sales_agent",
    nursingHome: "nursing_home",
    nurse: "nurse",
    monitoringStation: "monitoring_station",
    installer: "installer",
    supportsAgent: "supports_agent",
    endUser: "end_user",
    elderly: "elderly",
  });
  const [rolesFormatter, setRolesFormatter] = useState({
    super_admin: "Super Admin",
    distributor: "Distributor",
    office: "Office",
    sales_agent: "Sales Agent",
    nursing_home: "Nursing Home",
    nurse: "Nurse",
    monitoring_station: "Monitoring Station",
    installer: "Installer",
    supports_agent: "Supports Agent",
    end_user: "End User",
    elderly: "Elderly",
  });
  const [isAsssingInstaller, setIsAsssingInstaller] = useState(false);
  const [userDeleted, setUserDeleted] = useState(false);
  const [activeMemu, setActiveMenu] = useState("dashboard");
  let isLogin = null;
  const loggedUserToken = ls.get("token");
  if (loggedUserToken) {
    try {
      isLogin = jwtDecode(loggedUserToken)?.role;
    } catch (error) {
      if (error.name === "InvalidTokenError") {
        window.location.href = "/#/auth/login";
      }
    }
  }

  // --------------sleep events type mapping------------
  const [sleepEventsType, setSleepEventsType] = useState({
    0: "Deep Sleep",
    1: "Light Sleep",
    2: "Awake",
    3: "Out of Bed",
    4: "Offline",
    5: "Fall Asleep",
    7: "REM",
    13: "Breath Disruption",
    12: "Light Breathing Phase",
    11: "Deep Breathing Phase",
    14: "Elevated Activity Rhythm",
    15: "Relaxed Activity Rhythm",
    32: "Others",
    31: "Walking",
    30: "Still",
  });
  // --------------sleep events color mapping------------
  const [sleepEventsColor, setSleepEventsColor] = useState({
    "Deep Sleep": "#7F87FC",
    "Light Sleep": "#4285F4",
    Awake: "#F1A605",
    REM: "#A0C878",
    "Out of Bed": "#FF725E",
    "Fall Asleep": "#34CECE",
    "Breath Disruption": "#E416EB",
    "Deep Breathing Phase": "#9A7E6F",
    "Elevated Activity Rhythm": "#D91656",
    "Relaxed Activity Rhythm": "#FC8F54",
    "Light Breathing Phase": "#A19AD3",
    Offline: "#4DA1A9",
    Still: "#55FFEF",
    Walking: "#3AA0FF",
    Others: "#FCC575",
  });
  const [dailyRepDate, setDailyRepDate] = useState(null);
  const contextInfo = {
    sleepEventsType,
    dailyRepDate,
    setDailyRepDate,
    setSleepEventsType,
    sleepEventsColor,
    setSleepEventsColor,
    activeMemu,
    setActiveMenu,
    isLogin,
    userDeleted,
    setUserDeleted,
    allRoles,
    rolesFormatter,
    isAsssingInstaller,
    setIsAsssingInstaller,
    show,
    setShow,
    overView,
    setOverView,
    overViewActive,
    setOverViewActive,
    setinnerOverView,
    innerOverView,
    activeTrend,
    setActiveTrend,
    sidebarShow,
    setSidebarShow,
    setDeviceInner,
    deviceInner,
    setShowNotificationTab,
    showNotificationTab,
    setBreadCrumb,
    BreadCrumbData,
    role,
    setRole,
  };

  return (
    <SidebarContext.Provider value={contextInfo}>
      {children}
    </SidebarContext.Provider>
  );
};

export default SidebarContextProvider;
